class KlaviyoPopupCTA extends HTMLElement {
    constructor() {
      super();
      // Read configuration from the element dataset
      this.openKlaviyoPopupOnClick = this.dataset.openKlaviyoPopup === "true";
      this.klaviyoPopupIdDesktop = this.dataset.klaviyoPopupIdDesktop;
      this.klaviyoPopupIdMobile = this.dataset.klaviyoPopupIdMobile;
    }
  
    connectedCallback() {
      // Locate the CTA link within the component
      this.ctaLink = this.querySelector('a');
  
      // Bind the click handler and attach event listener
      if (this.ctaLink) {
        // Bind once and remove later if needed
        this.handleClickBound = this.handleClick.bind(this);
        this.ctaLink.addEventListener('click', this.handleClickBound);
      }
    }
  
    disconnectedCallback() {
      // Clean up the event listener
      this.ctaLink?.removeEventListener('click', this.handleClickBound);
    }
  
    handleClick(event) {
      if (this.openKlaviyoPopupOnClick) {
        // Prevent default anchor behavior
        event.preventDefault();
        // Determine device type to select appropriate popup ID
        const isMobile = window.innerWidth <= 768;
        const klaviyoPopupId = isMobile ? this.klaviyoPopupIdMobile : this.klaviyoPopupIdDesktop;
        if (window.GA4EventTracker?.trackKlaviyoPopupOpen) {
          window.GA4EventTracker.trackKlaviyoPopupOpen("klaviyo_popup_cta", {
            popup_id: klaviyoPopupId,
          });
        }
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', klaviyoPopupId]);
      }
    }
  }
  
  // Define the custom element
  customElements.define("klaviyo-popup-cta", KlaviyoPopupCTA);
